class Drawer extends HTMLElement {
  connectedCallback() {
    this.addEventListener(
      "keyup",
      (evt) => evt.code === "Escape" && this.close()
    );
    this.querySelector("[id*=-Overlay]").addEventListener(
      "click",
      this.close.bind(this)
    );
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);

    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      const mobileMenu = document.querySelector("mobile-menu");
        if (mobileMenu && typeof mobileMenu.mobilemenuHide === "function") {
          mobileMenu.mobilemenuHide();
        }
      document.body.classList.add("drawer--isActive");
      this.classList.add("animate", "active");
    });

    this.addEventListener(
      "transitionend",
      () => {
        const containerToTrapFocusOn = this.classList.contains("is-empty")
          ? this.querySelector(".drawer__inner-empty")
          : this.firstElementChild;
        const focusElement =
          this.querySelector(".drawer__inner") ||
          this.querySelector(".drawer__close");
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add("overflow-hidden");
  }

  close() {
    this.classList.remove("active");
    removeTrapFocus(this.activeElement);
    document.body.classList.remove("overflow-hidden");
    setTimeout(() => {
      document.body.classList.remove("drawer--isActive");
    }, 300);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

class DrawerButton extends Drawer {
  drawerTag = null;
  drawer = null;

  connectedCallback() {
    this.drawerTag = this.dataset.drawerTag;
    if (!this.drawerTag) {
      return;
    }

    this.drawer = document.querySelector(this.drawerTag);
    if (!this.drawer) {
      return;
    }

    this.addEventListener("click", () => {
      this.handleClick();
    });
  }

  handleClick() {
    let action = this.dataset.action ? this.dataset.action : "open";
    if (action === "open") {
      this.drawer.open();
    } else {
      this.drawer.close();
    }
  }
}

customElements.define("drawer-button", DrawerButton);

class SideDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener("drawer-toggle", () => {
      if (this.classList.contains("active")) {
        this.close(this);
      } else {
        this.open(this);
      }
    });

    this.addEventListener(
      "keyup",
      (evt) => evt.code === "Escape" && this.close()
    );

    this.onBodyClick = this.handleBodyClick.bind(this);
    this.onResize = this.drawerHeight.bind(this);

    this.drawerHeight();

    window.addEventListener("resize", this.onResize, { passive: true });
  }

  //Open drawer
  open(drawer) {
    this.classList.add("active");
    if (this.classList.contains("drawer--nav")) {
      document.body.classList.add("shadow--body");
      document.body.classList.add("nav-active");
    } else {
      document.body.classList.add("shadow");
    }

    this.addEventListener(
      "transitionend",
      () => {
        drawer.focus();
        trapFocus(drawer);
      },
      { once: true }
    );

    document.body.addEventListener("click", this.onBodyClick, {
      passive: true,
    });
    this.updateActiveNav();
  }

  //Close drawer
  close() {
    this.classList.remove("active");

    const activeDrawers = document.querySelectorAll("side-drawer.active");
    if (!activeDrawers.length) {
      if (this.classList.contains("drawer--nav")) {
        document.body.classList.remove("shadow--body");
        document.body.classList.remove("nav-active");
      } else {
        document.body.classList.remove("shadow");
      }

      // Does sidedrawer have a button with class bundle-product-card__variant-remove
      // That means a bundle variant was chosen so do the scroll to next step
      const bundleRemoveButton = this.querySelector(
        ".bundle-product-card__variant-remove"
      )

      const bundleVariantChosen = this.getAttribute('data-bundle-variant-chosen') === 'true';

      // get data-step attribute from drawer
      const step = this.getAttribute("data-step");

      if (bundleVariantChosen && step) {
        // get element with id 'step-' + step
        const nextStep = parseInt(step) + 1;
        const nextStepElement = document.getElementById("step-" + nextStep);
        if (nextStepElement) {
          // scroll to element
            const header = document.querySelector("header");
            const headerHeight = header ? header.offsetHeight : 0;
            const rect = nextStepElement.getBoundingClientRect();
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            const offsetTop = rect.top + scrollTop - headerHeight - 16;
            window.scrollTo({ top: offsetTop, behavior: "smooth" });
        }
      } else if (!step) {
        const scrollY = document.body.style.top;
        document.body.style.top = "";
        document.body.style.position = "";
        window.scrollTo(0, parseInt(scrollY || 0) * -1);
        document.body.removeEventListener("click", this.onBodyClick, {
          passive: true,
        });
      }
    }

    removeTrapFocus(this);
    this.updateActiveNav();
  }

  //Body click event to close drawer
  handleBodyClick(evt) {
    const target = evt.target;
    if (
      target !== this &&
      !target.closest("side-drawer") &&
      !target.closest("side-drawer-toggle") &&
      !target.closest(".product-media-modal") &&
      !target.closest(".bundle-product-card__bundle-remove")
    ) {
      this.close();
    }
  }

  //recalculate height of drawer when viewport changes
  drawerHeight() {
    document.documentElement.style.setProperty(
      "--app-height",
      `${window.innerHeight}px`
    );
  }

  updateActiveNav() {
    const navLinks = document.querySelectorAll(".js-nav-link");
    if (navLinks.length) {
      navLinks.forEach((link) => {
        const linkDrawer = document.getElementById(
          link.getAttribute("data-drawer")
        );
        if (linkDrawer && linkDrawer.classList.contains("active")) {
          link.classList.add("active");
        } else {
          link.classList.remove("active");
        }
      });
    }
  }
}

customElements.define("side-drawer", SideDrawer);
